import { gql, useLazyQuery } from '@apollo/client';
import { useState } from 'react';
import { MODULE_FRAGMENTS, COMPONENT_FRAGMENTS } from './fragments';

export const GET_OVERLAY_DATA = gql`
  ${COMPONENT_FRAGMENTS.IMAGE}
  ${COMPONENT_FRAGMENTS.CTA}
  ${MODULE_FRAGMENTS.IMAGE}
  ${COMPONENT_FRAGMENTS.STAT_CARD}
  ${COMPONENT_FRAGMENTS.CTA_CARD}
  ${MODULE_FRAGMENTS.MARKDOWN_TEXT}
  ${MODULE_FRAGMENTS.SECTION_DIVIDER}
  ${MODULE_FRAGMENTS.FOOTNOTES}
  ${MODULE_FRAGMENTS.FEATURE_CARD}
  ${MODULE_FRAGMENTS.QUOTE}
  ${COMPONENT_FRAGMENTS.CTA_BANNER}
  ${MODULE_FRAGMENTS.VIDEO_FEATURE_CARD}
  ${MODULE_FRAGMENTS.GALLERY}
  ${MODULE_FRAGMENTS.AUDIO}
  ${MODULE_FRAGMENTS.VIDEO}

  query GetOverlayData($id: String!) {
    overlayCollection(where: { sys: { id: $id } }, limit: 1) {
      items {
        sys {
          id
        }
        name
        title
        eyebrow
        backgroundColor
        textColor
        modulesCollection {
          items {
            ... on ModuleFeatureCard {
              ...FeatureCard
            }
            ... on ModuleImage {
              ...Image
            }
            ... on ModuleQuote {
              ...Quote
            }
            ... on ModuleMarkdownText {
              ...MarkdownText
            }
            ... on ModuleSectionDivider {
              ...SectionDivider
            }
            ... on ModuleFootnotes {
              ...Footnotes
            }
            ... on CtaBanner {
              ...ctaBanner
            }
            ... on ModuleVideoFeatureCard {
              ...VideoFeatureCard
            }
            ... on ModuleGallery {
              ...Gallery
            }
            ... on ModuleAudio {
              ...Audio
            }
            ... on ModuleVideo {
              ...Video
            }
          }
        }
      }
    }
  }
`;

export const useOverlay = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayData, setOverlayData] = useState(null);

  const [getOverlayData, { loading: overlayLoading }] = useLazyQuery(
    GET_OVERLAY_DATA,
    {
      onCompleted: data => {
        if (
          data?.overlayCollection?.items &&
          data.overlayCollection.items.length > 0
        ) {
          setOverlayData(data.overlayCollection.items[0]);
          setShowOverlay(true);
        } else {
          setOverlayData(null);
          setShowOverlay(false);
        }
      },
    },
  );

  const handleOverlayOpen = id => {
    if (id) {
      getOverlayData({ variables: { id } });
    }
  };

  const handleOverlayClose = () => {
    setShowOverlay(false);
    setOverlayData(null);
  };

  return {
    showOverlay,
    overlayData,
    overlayLoading,
    handleOverlayOpen,
    handleOverlayClose,
  };
};
